import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import Tippy from "@tippyjs/react";
import classNames from "classnames";
import { DocumentTypeIcon, ThemedSpan } from "../utilities"
import { DocumentType } from "../../types/DocumentType";
import { niceBytes } from "../../helpers/fileHelpers";

export type EmailAttachmentDocumentProps = DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    data: DocumentType
};

export const EmailAttachmentDocument = ({ className, data, ...props } : Readonly<EmailAttachmentDocumentProps>) : JSX.Element => (
    <Tippy placement="auto" content={(
        <span>{data.fileName}</span>
    )}>
        <button type="button" className={classNames(
            "btn btn-outline-light text-dark d-flex flex-row align-items-center text-start", 
            className
        )} {...props}>
            <DocumentTypeIcon 
                type={data.documentType} 
                outerElement={{
                    className: "d-flex justify-content-center align-items-center px-1 me-2"
                }}
            />
            <p className="text-truncate m-0 lh-1">
                <ThemedSpan variant="primary">{data.fileName}</ThemedSpan>
                <br/>
                <ThemedSpan variant="muted" className="fs-smallest">{niceBytes(data.fileSize)}</ThemedSpan>
            </p>
        </button>
    </Tippy>
);